import '@/favorites/app'
import { initTier2NotCheckout } from '@/pages/_shared/not-checkout/tier2'
import { initPageTier } from '@/pages/_shared/tier-utils'
import { registerHandlerElementDetailsModalScript } from '@/utils/queues/handlers/element/details-modal-script'
import { initializeColorSelection } from '@/catalog/product-color-selection'
import { initializePopovers } from '@/catalog/product-popovers'
import { initializeInfoTabs } from '@/catalog/product-info-tabs'
import { initializeMatchingItems } from '@/catalog/product-matching-items'
import { initializeSubstrates } from '@/catalog/product-substrates'
import { initializeNavbar } from '@/catalog/product-navbar'
import { initializeSwiperSuiteVariations } from '@/catalog/product-swiper-suite-variations'

export const initTier2 = async (): Promise<void> => {
  await initPageTier(2, [
    initTier2NotCheckout,
    async (): Promise<void> => {
      registerHandlerElementDetailsModalScript()
      // Make page interactive
      initializeNavbar()
      initializeSwiperSuiteVariations()
      initializeColorSelection()
      initializeSubstrates()
      initializeInfoTabs()
      initializePopovers()
      initializeMatchingItems()
    }
  ])
  // `webpackPrefetch` prefetches the next tier at `Lowest` network priority when the current tier is loaded,
  // even before the following `import()` is executed.
  import(
    /* webpackChunkName: '@/product/tier3', webpackPrefetch: true */ './tier3'
  ).then(({ initTier3 }) => initTier3())
}
